/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const Crosshairs = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5703_44951)">
          <path
            d="M12.708 0V3.1377C17.028 3.4917 20.4722 6.94841 20.8262 11.2744H23.9639V12.7256H20.8262C20.4782 17.0516 17.028 20.5083 12.708 20.8623V24H11.2559V20.8623C6.93596 20.5082 3.49169 17.0515 3.1377 12.7256H0V11.2744H3.1377C3.48569 6.94849 6.93596 3.49179 11.2559 3.1377V0H12.708ZM11.9824 4.71582C7.97442 4.71582 4.71582 7.986 4.71582 12C4.71582 16.014 7.97442 19.2842 11.9824 19.2842C15.9903 19.284 19.248 16.0139 19.248 12C19.248 7.98611 15.9903 4.716 11.9824 4.71582ZM11.9824 7.14648C14.6584 7.14648 16.831 9.31805 16.8311 12C16.8311 14.682 14.6584 16.8545 11.9824 16.8545C9.30658 16.8543 7.13477 14.6819 7.13477 12C7.13483 9.31817 9.30662 7.14667 11.9824 7.14648Z"
            fill="#002967"
          />
        </g>
        <defs>
          <clipPath id="clip0_5703_44951">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5703_44963)">
        <path
          d="M8.47168 0V2.0918C11.3515 2.32779 13.6476 4.63181 13.8838 7.51562H15.9766V8.48438H13.8838C13.6516 11.3682 11.3515 13.6722 8.47168 13.9082V16H7.50391V13.9082C4.6241 13.6721 2.32795 11.3682 2.0918 8.48438H0V7.51562H2.0918C2.32395 4.63185 4.6241 2.32787 7.50391 2.0918V0H8.47168ZM7.98828 3.14355C5.31628 3.14355 3.14453 5.324 3.14453 8C3.14453 10.676 5.31628 12.8564 7.98828 12.8564C10.6602 12.8563 12.832 10.6759 12.832 8C12.832 5.32406 10.6602 3.14365 7.98828 3.14355ZM7.98828 4.76367C9.77225 4.76367 11.2207 6.21204 11.2207 8C11.2207 9.788 9.77228 11.2363 7.98828 11.2363C6.20439 11.2362 4.75684 9.78792 4.75684 8C4.75688 6.21211 6.20441 4.7638 7.98828 4.76367Z"
          fill="#002967"
        />
      </g>
      <defs>
        <clipPath id="clip0_5703_44963">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Crosshairs;
